import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { CommonError } from '../stores/app-state-errors';

export const ERROR_REASONS_TO_ALWAYS_RENDER = [
  ErrorReason.INVALID_STATE_REDIRECT_URI,
  ErrorReason.INVALID_STATE_SCOPE,
  ErrorReason.INVALID_PARAMETER_INPUT_USERNAME,
  ErrorReason.INVALID_PARAMETER_SCOPE,
  ErrorReason.INVALID_PARAMETER_CLIENT_ID,
  ErrorReason.INVALID_PARAMETER_REDIRECT_URI,
  ErrorReason.INVALID_PARAMETER_PAYMENT_REQUEST_ID,
  ErrorReason.INVALID_PARAMETER_INPUT_PROVIDER,
  ErrorReason.INVALID_PARAMETER_AUTHORIZATION_CODE,
  ErrorReason.INVALID_PARAMETER_REFRESHABLE_ITEMS,
  ErrorReason.INVALID_PARAMETER_CREDENTIALS_ID,
  ErrorReason.INVALID_PARAMETER_FINANCIAL_SERVICES_SEGMENTS,
  ErrorReason.INVALID_PARAMETER_REPORT_TYPES,
  ErrorReason.INVALID_PARAMETER_ACCOUNT_DIALOG_TYPE,
  ErrorReason.INVALID_PARAMETER,
  ErrorReason.INVALID_PARAMETER_PRODUCTS,
  ErrorReason.REQUEST_FAILED_OAUTH_DESCRIBE,
  ErrorReason.REQUEST_FAILED_CREATE_ANONYMOUS_USER,
  ErrorReason.REQUEST_FAILED_FETCH_EXISTING_USER,
  ErrorReason.REQUEST_FAILED_FETCH_USER_WITH_EXISTING_TOKEN,
  ErrorReason.INVALID_STATE_EMBED_NOT_ALLOWED,
  ErrorReason.INVALID_STATE_REDIRECTED_CREDENTIALS_ID,
  ErrorReason.INVALID_STATE_REDIRECTED_AUTHORIZATION_TOKEN,
  ErrorReason.REQUEST_FAILED_CONSUME_HANDOFF_SESSION,
  ErrorReason.REQUEST_FAILED_FETCH_CONFIGURATION,
];

/**
 * When the user explicity want to cancel,
 * then always redirect or postMessage.
 * These should not be rendered in Tink Link.
 */
export const ERROR_REASONS_TO_NEVER_RENDER = [
  ErrorReason.USER_CANCELLED,
  ErrorReason.INVALID_STATE_PAYMENT_RETRY_NOT_ALLOWED,
  ErrorReason.FAILED_FRAUD_PREVENTION_CHECK,
  ErrorReason.FAILED_BULK_PAYMENT,
  ErrorReason.PARTIALLY_FAILED_BULK_PAYMENT,
];

export const getErrorMessageFromStatusCode = (statusCode: number): string => {
  switch (statusCode) {
    case 400:
      return 'Bad request';
    case 401:
      return 'You need to be logged in';
    case 404:
      return 'Was not able to find the searched for resource';
    case 500:
      return 'An unexpected error occurred, please try again.';
    default:
      return 'Something went wrong, please try again';
  }
};

export const RESETTING_CREDENTIALS_FAILED: CommonError = {
  errorStatus: ErrorStatus.TEMPORARY_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_CREATE_RESET_CREDENTIALS,
};

export const FETCHING_CREDENTIALS_FAILED: CommonError = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_FETCH_CREDENTIALS,
};

export const CREDENTIALS_ID_PARAMETER_INVALID: CommonError = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_PARAMETER_CREDENTIALS_ID,
};

export const CREDENTIALS_STATE_INVALID: CommonError = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_STATE_CREDENTIALS,
};

export const PERMANENT_USER_FLAG_NOT_ENABLED: CommonError = {
  errorStatus: ErrorStatus.TEMPORARY_ERROR,
  errorReason: ErrorReason.INVALID_STATE_PERMANENT_USER_FLAG,
};

export const ERR_USER_CANCELLED: CommonError = {
  errorStatus: ErrorStatus.USER_CANCELLED,
  errorReason: ErrorReason.USER_CANCELLED,
};

export const ERR_FAILED_CREATE_AUTHORIZATION_CODE: CommonError = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_CREATE_AUTHORIZATION_CODE,
};

export const ERR_PARAM_REFRESHABLE_ITEMS_INVALID = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_PARAMETER_REFRESHABLE_ITEMS,
};

export const ERR_PARAM_CONSENT_ID_INVALID = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_PARAMETER_CONSENT_ID,
};

export const ERR_PARAM_AUTHORIZATION_CODE_INVALID = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_PARAMETER_AUTHORIZATION_CODE,
};

export const ERR_PROVIDER_NOT_FOUND = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_STATE_PROVIDER,
};

export const ERR_INVALID_PARAMETER_EXTERNAL_REFERENCE = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_PARAMETER_EXTERNAL_REFERENCE,
};

export const ERR_BULK_PARTIALLY_FAILED: CommonError = {
  errorStatus: ErrorStatus.TEMPORARY_ERROR,
  errorReason: ErrorReason.PARTIALLY_FAILED_BULK_PAYMENT,
};

export const ERR_BULK_FAILED: CommonError = {
  errorStatus: ErrorStatus.TEMPORARY_ERROR,
  errorReason: ErrorReason.FAILED_BULK_PAYMENT,
};

export const ERR_FETCH_DEMOBANK_SCENARIOS_FAILED = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_FETCH_DEMOBANK_SCENARIOS,
};

export const ERR_FETCH_REGION_MAPPING = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_FETCH_REGION_MAPPINGS,
};
